import React, { useState, useRef, useEffect } from "react";
import { Html5Qrcode } from "html5-qrcode";
import Swal from "sweetalert2";
import LoadMask from "../../Utils/LoadMask/LoadMask";
import "./style.css";

const QrView = ({ qrRead, loader }) => {
    const [facingMode, setFacingMode] = useState("environment");
    const [scanning, setScanning] = useState(false);
    const scannerRef = useRef(null);
    const containerId = "qr-reader-container";

    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    const startScanner = async (facing) => {
        if (scannerRef.current) {
            try {
                await scannerRef.current.stop();
                await scannerRef.current.clear();
            } catch (_) {}
        }

        const html5QrCode = new Html5Qrcode(containerId);
        scannerRef.current = html5QrCode;

        try {
            await html5QrCode.start(
                { facingMode: facing },
                { fps: 10, qrbox: { width: 220, height: 220 } },
                (decodedText) => {
                    if (loader) return;
                    if (!decodedText.includes("/users_open/")) {
                        Swal.fire({
                            icon: "error",
                            title: "ERROR",
                            text: "El codigo QR no es valido para la plataforma",
                        });
                    } else {
                        qrRead(decodedText.split("/users_open/")[1].replace("/", ""));
                    }
                },
                () => {} // onError ignorado silenciosamente
            );
            setScanning(true);
        } catch (err) {
            const errName = (err && err.name) || (err && err.toString()) || "";
            if (!["NotReadableError", "OverconstrainedError", "AbortError"].some(e => errName.includes(e))) {
                Swal.fire({ icon: "error", title: "ERROR", text: String(err) });
            }
        }
    };

    useEffect(() => {
        startScanner(facingMode);
        return () => {
            if (scannerRef.current) {
                scannerRef.current.stop().catch(() => {});
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [facingMode]);

    const toggleCamera = () => {
        setScanning(false);
        setFacingMode(prev => (prev === "environment" ? "user" : "environment"));
    };

    return (
        <LoadMask loading={loader} blur>
            <div className="qr-container d-flex flex-column align-items-center">
                <div
                    id={containerId}
                    style={{ width: 250, height: 250, overflow: "hidden" }}
                />
                {isMobile && (
                    <button
                        className="btn btn-primary mt-3"
                        onClick={toggleCamera}
                        disabled={!scanning}
                        style={{ zIndex: 1000 }}
                    >
                        <i className="fa fa-camera-retro mr-2"></i>
                        Cambiar Cámara
                    </button>
                )}
            </div>
        </LoadMask>
    );
};

export default QrView;